<div class="new-preset-overlay">
	<mat-form-field appearance="fill" class="full-width">
		<mat-label>{{'PRESET_TITLE' | translate}}</mat-label>
		<input required [(ngModel)]="presetName" matInput name="preset_name">
		<mat-error>
			<ng-container *ngIf="!presetName">{{ 'FIELD_IS_REQUIRED' | translate }}</ng-container>
		</mat-error>
	</mat-form-field>

	<ul class="asset-list">
		<div class="table-header asset">
			<span class="header" *ngFor="let column of columsToDisplay">
				{{ column | translate}}
			</span>
		</div>
		<li *ngFor="let asset of assets; let i = index">
			<label [class.no-pointer]="asset.disabled">
				<bb-check [(ngModel)]="asset.checked" [checked]="asset.checked" (ngModelChange)="assetsChanged(asset, $event)"
					[ngModelOptions]="{standalone: true}" [disabled]="asset.disabled"></bb-check>
				<div class="media-table">
					<span class="asset">
						{{ asset.mediaformat }}
					</span>
					<span class="asset">
						{{ asset.name }}
					</span>
					<span class="asset">
						{{ asset.title }}
					</span>
					<span class="asset">
						{{ asset.bandwidth }} kpbs
					</span>
				</div>
			</label>
		</li>
	</ul>
	
	<span class="button add-group" (click)="onSaveClick()" >{{'SAVE_PRESET' | translate}}</span>
</div>
